/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { ILinkProps, Link } from '@fluentui/react/lib/Link';
import { getStylist, important } from 'src/core/themes/luisStylist';

const { styleDiv, styleComponent } = getStylist('Dashboard');

export const Label = styleDiv('HeaderLabel', theme => ({
    display: 'table-cell',
    verticalAlign: 'middle',
    fontSize: theme.labelFontSize,
    lineHeight: theme.mediumLineHeight,
    letterSpacing: theme.xLargeLetterSpacing,
    $nest: {
        button: {
            verticalAlign: 'middle'
        }
    }
}));

export const NumericLabel = styleComponent(Label)('NumericLabel', theme => ({
    paddingLeft: theme.detailedFaultyIntentLegendSpacing,
    textAlign: 'right'
}));

export const StyledLink = styleComponent<ILinkProps>(Link)('StyledLink', theme =>
    important({ color: theme.correctColor, textDecoration: 'none' })
);
